import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AasicItemYesNo,
  formClassCorp,
  FormKbn,
  Status,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { httpAPI_CON005, httpAPI_CON012 } from "./api/request";
import { fakeTableList, schema, steps } from "./parts";
import { IAPI_CON012_Request } from "../../type/apiType";
import _ from "lodash";

/**
 * SCRC040004 「俸給の調整額」新規申請
 * @return SCRC040004 「俸給の調整額」新規申請
 */
const SCRC040004 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: globalState, setState } = useContext(GlobalContext);
  const [tableList, setTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [contentsView, setContentsView] = useState<
    { submitButtonDisabled: boolean; submitButtonText: string }[] | undefined
  >([
    {
      submitButtonDisabled: false,
      submitButtonText: "一時保存",
    },
    {
      submitButtonDisabled: false,
      submitButtonText: "機構へ提出する",
    },
  ]);
  const [openSave, setOpenSave] = useState(false);
  const [openSubmit, setOpenSubmit] = useState(false);
  const httpReq = useRef<IAPI_CON012_Request>({});
  const [tempSaveStepFlg, setTempSaveStepFlg] = useState(false);

  const applyId =
    location.state?.applyId ??
    businessState.job_07?.applyId ??
    businessState.job_08?.applyId;
  const isKiKo =
    globalState.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiKo
    ? businessState.common?.contractorNo
    : globalState.authInfo?.contractorNo;

  async function openingScreen() {
    if (!applyId) {
      try {
        //「俸給の調整額」対象手当参照API実行
        const res = await httpAPI_CON005({
          contractorNo,
          allowanceSerialNo: location.state?.allowanceHisSerialNo,
        });

        if (res.resultCd === "I0000") {
          let resArr = stateFakeTableList.current;
          const disabledValue = location.state?.allowanceHisSerialNo;

          // 手当の一覧
          let allowanceKbnList: any[] = [];
          res.approvedAllowanceList?.forEach?.((item: any) => {
            allowanceKbnList.push(item?.approvedAllowanceKbnExtras);
          });
          resArr.find((item) => item.keyword === "benefitsList")!.text =
            allowanceKbnList.join("、");

          // 申請手当名
          resArr.find(
            (item) => item.keyword === "applyBenefitsName"
          )!.setDefaultValue = {
            selectValue: res.allowanceKbn,
            inputValue: res.allowanceKbnExtras,
          };

          // 対応規程
          resArr.find(
            (item) => item.keyword === "parallelRule"
          )!.setDefaultValue = !isNaN(Number(res.salaryRegulations!))
            ? res.salaryRegulations
            : "";

          // 手当の支給金額の目安
          resArr.find(
            (item) => item.keyword === "minAndMaxAmt"
          )!.setDefaultValue = {
            max: res.maxAmt,
            min: res.minAmt,
          };

          // 非活性
          resArr.forEach((item: any) => {
            if (item.keyword === "minAndMaxAmt") {
              item.disabledMax = disabledValue;
              item.disabledMin = disabledValue;
            } else if (item.keyword.includes("checkBox")) {
              item.checkBoxList = item.checkBoxList?.map?.((element: any) => {
                return {
                  ...element,
                  disabled: disabledValue,
                };
              });
            } else {
              item.disabled = disabledValue;
            }
            return item;
          });

          // 対象施設
          const facilityList = [];
          const checkedList = [];
          if (!!res.facilityList?.length) {
            for (let i in res.facilityList) {
              const data = {
                label:
                  (res.facilityList[i]?.facilityNo ?? "") +
                  ":" +
                  (res.facilityList[i]?.facilityName ?? ""),
                value: res.facilityList[i]?.facilityNo,
                disabled: disabledValue,
              };
              if (res.facilityList[i]?.facilityFlg === "1") {
                checkedList.push(data.label);
              }
              facilityList.push(data);
            }
          }
          let targetFacilities = resArr.find(
            (item) => item.keyword === "targetFacilities"
          )!;
          targetFacilities.checkBoxList = facilityList;
          targetFacilities.setDefaultValue = checkedList;

          // 条文
          resArr.find((item) => item.keyword === "article")!.setDefaultValue =
            res.salaryText;

          // 基本項目
          let i: number;
          for (i = 1; i <= 4; i++) {
            let j = i;
            const checkBox = resArr.find(
              (item) => item.keyword === "checkBox" + j.toString()
            )!;
            checkBox.checkBoxList?.map(
              (item: any) => (item.disabled = disabledValue)
            );
            checkBox.setDefaultValue =
              res.basicItem1 === AasicItemYesNo["はい、表記があります"]
                ? ["はい、表記があります"]
                : [];
          }

          // 給与規程
          const file = res.formList?.find?.(
            (item: any) => item?.formClass === formClassCorp["給与規程"]
          );
          const salaryRules = resArr.find(
            (item) => item.keyword === "salaryRules"
          );
          if (disabledValue) {
            salaryRules!.downloadBase64 = true;
            salaryRules!.type = "downloadLink";
            salaryRules!.base64filedata = file?.fileBase64 ?? "";
            salaryRules!.dataname = file?.fileName ?? "";
          } else {
            file &&
              (salaryRules!.setDefaultValue = [
                {
                  formName: file?.fileName ?? "",
                  fileBase64: file?.fileBase64 ?? "",
                },
              ]);
          }

          // ボタン
          setContentsView(
            disabledValue
              ? []
              : [
                  {
                    submitButtonDisabled: disabledValue,
                    submitButtonText: "一時保存",
                  },
                  {
                    submitButtonDisabled: disabledValue,
                    submitButtonText: isKiKo ? "申請" : "機構へ提出する",
                  },
                ]
          );

          setTableList([...resArr]);
          setState({
            ...globalState,
            errorMsgId: "",
          });
        } else {
          setState({
            ...globalState,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      try {
        //「俸給の調整額」対象手当参照API実行
        const res = await httpAPI_CON005({
          contractorNo,
          applyId,
        });
        if (res.resultCd === "I0000") {
          let resArr = stateFakeTableList.current;
          const disabledValue = !(
            res.latestApplyStatus === Status["届出待ち"] ||
            res.latestApplyStatus === Status["差戻し一時保存"]
          );

          setContentsView(
            disabledValue
              ? []
              : [
                  {
                    submitButtonDisabled: disabledValue,
                    submitButtonText: "一時保存",
                  },
                  {
                    submitButtonDisabled: disabledValue,
                    submitButtonText: isKiKo ? "申請" : "機構へ提出する",
                  },
                ]
          );
          resArr.forEach((item: any) => {
            if (item.keyword === "minAndMaxAmt") {
              item.disabledMax = disabledValue;
              item.disabledMin = disabledValue;
            } else if (item.keyword.includes("checkBox")) {
              item.checkBoxList?.map((element: any) => {
                return {
                  ...element,
                  disabled: disabledValue,
                };
              });
            } else {
              item.disabled = disabledValue;
            }
            return item;
          });
          // 手当の一覧
          let allowanceKbnList: any[] = [];
          res.approvedAllowanceList?.forEach((item: any) => {
            allowanceKbnList.push(item.approvedAllowanceKbnExtras);
          });

          resArr.find((item) => item.keyword === "benefitsList")!.text =
            allowanceKbnList.join("、");
          // 申請手当名
          resArr.find(
            (item) => item.keyword === "applyBenefitsName"
          )!.setDefaultValue = {
            selectValue: res.allowanceKbn,
            inputValue: res.allowanceKbnExtras,
          };

          // 対応規程
          resArr.find(
            (item) => item.keyword === "parallelRule"
          )!.setDefaultValue = !isNaN(Number(res.salaryRegulations!))
            ? res.salaryRegulations
            : "";

          // 手当の支給金額の目安
          resArr.find(
            (item) => item.keyword === "minAndMaxAmt"
          )!.setDefaultValue = {
            max: res.maxAmt,
            min: res.minAmt,
          };
          // 対象施設
          const facilityList = [];
          const checkedList = [];
          if (res.facilityList) {
            for (let i in res.facilityList) {
              const data = {
                label:
                  (res.facilityList[i].facilityNo ?? "") +
                  ":" +
                  (res.facilityList[i].facilityName ?? ""),
                value: res.facilityList[i].facilityNo,
                disabled: disabledValue,
              };
              if (res.facilityList[i].facilityFlg === "1") {
                checkedList.push(data.label);
              }
              facilityList.push(data);
            }
          }
          let targetFacilities = resArr.find(
            (item) => item.keyword === "targetFacilities"
          )!;
          targetFacilities.checkBoxList = facilityList;
          targetFacilities.setDefaultValue = checkedList;
          // 条文
          resArr.find((item) => item.keyword === "article")!.setDefaultValue =
            res.salaryText;
          // 基本項目
          let i: number;
          for (i = 1; i <= 4; i++) {
            let j = i;
            const checkBox = resArr.find(
              (item) => item.keyword === "checkBox" + j.toString()
            )!;
            checkBox.checkBoxList?.map(
              (item: any) => (item.disabled = disabledValue)
            );
            checkBox.setDefaultValue =
              res.basicItem1 === AasicItemYesNo["はい、表記があります"]
                ? ["はい、表記があります"]
                : [];
          }

          // 給与規程
          const file = res.formList?.find?.(
            (item: any) => item?.formClass === formClassCorp["給与規程"]
          );
          const salaryRules = resArr.find(
            (item) => item.keyword === "salaryRules"
          );
          if (disabledValue) {
            salaryRules!.type = "downloadLink";
            salaryRules!.base64filedata = file?.fileBase64 ?? "";
            salaryRules!.dataname = file?.fileName ?? "";
            salaryRules!.downloadBase64 = true;
          } else {
            salaryRules!.setDefaultValue = [
              {
                formName: file?.fileName ?? "",
                fileBase64: file?.fileBase64 ?? "",
              },
            ];
          }

          setTableList([...resArr]);
          setState({
            ...globalState,
            errorMsgId: "",
          });
        } else {
          setState({
            ...globalState,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    }
  }
  useEffect(() => {
    // 契約者（法人）名
    let resArr = stateFakeTableList.current;
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.showLine = isKiKo;
    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;
    setTableList([...resArr]);

    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clickSubmit = (data: any, index: any) => {
    httpReq.current = makeReqData(data);
    switch (index) {
      case 0: // 一時保存
        setTempSaveStepFlg(true);
        handleUpdate(0);
        break;
      case 1: // 機構へ提出する/申請
        setOpenSubmit(true);
    }
  };

  const makeReqData = (data: any) => {
    const facilityList = data.targetFacilities?.map((item: any) => {
      const facilityNo = item.split(":");
      return { facilityNo: facilityNo[0] };
    });

    const formList = data.salaryRules?.map((item: any) => {
      return {
        serialNo: 1,
        facilityNo: "",
        staffNo: "",
        formKbn: FormKbn["法人書類"],
        formClass: formClassCorp["給与規程"],
        fileName: item.formName,
        fileBase64: item.fileBase64,
      };
    });

    const reqData: any = {
      applyId,
      tempSaveStep: tempSaveStepFlg ? "1" : null,
      contractorNo,
      allowanceKbn: data.applyBenefitsName?.selectValue,
      allowanceKbnExtras: data.applyBenefitsName?.inputValue,
      salaryRegulations: data.parallelRule,
      maxAmt: data.minAndMaxAmt?.max,
      minAmt: data.minAndMaxAmt?.min,
      facilityList: facilityList,
      salaryText: data.article,
      basicItem1: data.checkBox1?.length > 0 ? "1" : "0",
      basicItem2: data.checkBox2?.length > 0 ? "1" : "0",
      basicItem3: data.checkBox3?.length > 0 ? "1" : "0",
      basicItem4: data.checkBox4?.length > 0 ? "1" : "0",
      formList: formList,
      screenId: "SCRC040004",
      continueApplyFlg:
        location.state?.continueApplyFlg !== undefined &&
        location.state?.continueApplyFlg !== ""
          ? location.state?.continueApplyFlg
          : "0",
    };

    return reqData;
  };

  const handleUpdate = async (index: any, date?: any) => {
    try {
      const res = await httpAPI_CON012({
        ...httpReq.current,
        receptionDate: date,
        tempSaveStep: index === 1 ? undefined : 1,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...globalState,
          errorMsgId: "",
        });

        switch (index) {
          case 0: // 一時保存
            setOpenSave(true);
            setBusinessState({
              ...businessState,
              job_07: {
                applyId: res.applyId,
              },
            });
            break;

          case 1: // 機構へ提出する/申請
            navigate("/SCRC070008");
        }
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });

        setOpenSubmit(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC040004PageForTest" className="tkSCRC040004">
      <TkStepper steps={steps} activeStep={1} />

      <TkFakeTable
        list={tableList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={(e, index) => clickSubmit(e, index)}
        submitButtonGroup={contentsView}
      />

      <TkMessageDialog
        open={openSave}
        onOky={() => setOpenSave(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />

      {isKiKo ? (
        <TkDateDialog
          open={openSubmit}
          title="確認（申請を行います）"
          contextText="申請を行いますが、問題ないでしょうか。"
          okText="はい"
          cancelText="いいえ"
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          onOky={(e: any) => handleUpdate(1, e)}
          onCancel={() => setOpenSubmit(false)}
        />
      ) : (
        <TkMessageDialog
          open={openSubmit}
          title="確認（機構へ提出します）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          okText="はい"
          cancelText="いいえ"
          onOky={() => handleUpdate(1)}
          onCancel={() => setOpenSubmit(false)}
        />
      )}
    </Box>
  );
};
export default SCRC040004;
